module.exports = __webpack_public_path__ + "static/img/2.df74429.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/internationalBrand/kmR22/2.jpg
// module id = b/jF
// module chunks = 1